<template>
  <div v-if="showDialog" class="video-play-box">
    <div class="video-play-body">
      <div class="video-box">
        <video class="video" :src="videoSrc" controls></video>
      </div>
      <div class="btn-close" @click="handleCloseVideo"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VideoPlay",
  props: {
    videoSrc: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    navIndex: function () {
      let _this = this;
      let idx = _this.$store.state.navIndex;
      return idx;
    },
  },
  methods: {
    handleCloseVideo: function () {
      let _this = this;
      _this.showDialog = false;
    },
  },
};
</script>
<style scoped lang="less">
.video-play-box {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  z-index: 2;
  .video-play-body {
    position: fixed;
    width: 1200px;
    height: 680px;
    background: #fff;
    border-radius: 4px;
    border: 4px solid rgb(238, 238, 238);
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    .video-box {
      position: relative;
      width: 100%;
      height: 100%;
      background: #000;
      .video {
        width: 100%;
        height: 100%;
      }
    }

    .btn-close {
      position: absolute;
      width: 34px;
      height: 34px;
      right: 15px;
      top: 15px;
      background: url("../assets/icon_deleted.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
